import { render, staticRenderFns } from "./MySidebarNav.vue?vue&type=template&id=470f0bd3&scoped=true&"
import script from "./MySidebarNav.vue?vue&type=script&lang=js&"
export * from "./MySidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./MySidebarNav.vue?vue&type=style&index=0&id=470f0bd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f0bd3",
  null
  
)

export default component.exports